const rankings = [
  { rank: 1, title: '流浪地球3', category: '电影 · 科幻', score: '9.5', trend: 'up', change: '+2' },
  { rank: 2, title: '长安十二时辰', category: '电视剧 · 古装', score: '9.2', trend: 'up', change: '+1' },
  { rank: 3, title: '繁花似锦', category: '电视剧 · 都市', score: '8.9', trend: 'same', change: '0' },
  { rank: 4, title: '猎罪图鉴', category: '电视剧 · 悬疑', score: '9.1', trend: 'up', change: '+3' },
  { rank: 5, title: '破晓行动', category: '电影 · 动作', score: '9.0', trend: 'down', change: '-1' },
  { rank: 6, title: '山河令', category: '电视剧 · 仙侠', score: '8.8', trend: 'down', change: '-2' },
  { rank: 7, title: '深海迷踪', category: '电影 · 惊悚', score: '8.7', trend: 'up', change: '+4' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">热播榜单</h2>
          <p className="text-foreground-500 text-sm mt-2">实时热度排行，发现大家都在看的好内容</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-300/30 overflow-hidden">
          <div className="hidden sm:grid grid-cols-12 gap-4 px-6 py-3 bg-background-100 border-b border-background-300/20">
            <span className="col-span-1 text-foreground-600 text-xs font-semibold">排名</span>
            <span className="col-span-5 text-foreground-600 text-xs font-semibold">作品</span>
            <span className="col-span-3 text-foreground-600 text-xs font-semibold">类型</span>
            <span className="col-span-2 text-foreground-600 text-xs font-semibold text-center">评分</span>
            <span className="col-span-1 text-foreground-600 text-xs font-semibold text-center">趋势</span>
          </div>

          {rankings.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-4 px-4 sm:px-6 py-4 items-center border-b border-background-300/10 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer"
            >
              <div className="col-span-1 flex items-center gap-3 sm:gap-0">
                <span
                  className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-black shrink-0 ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-primary-500/70 text-background-50'
                      : item.rank === 3
                      ? 'bg-primary-500/40 text-primary-100'
                      : 'bg-secondary-100 text-secondary-900'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="sm:hidden text-foreground-100 font-bold text-sm">{item.title}</span>
              </div>
              <span className="hidden sm:block col-span-5 text-foreground-100 font-bold text-sm">
                {item.title}
              </span>
              <span className="col-span-3 text-foreground-600 text-xs sm:pl-0 pl-11">{item.category}</span>
              <div className="col-span-2 flex justify-start sm:justify-center pl-11 sm:pl-0">
                <span className="text-primary-400 font-black text-sm">{item.score}</span>
              </div>
              <div className="col-span-1 flex justify-start sm:justify-center pl-11 sm:pl-0">
                {item.trend === 'up' ? (
                  <span className="inline-flex items-center gap-1 text-accent-400 text-xs font-medium whitespace-nowrap">
                    <i className="ri-arrow-up-line"></i>{item.change}
                  </span>
                ) : item.trend === 'down' ? (
                  <span className="inline-flex items-center gap-1 text-foreground-600 text-xs font-medium whitespace-nowrap">
                    <i className="ri-arrow-down-line"></i>{item.change}
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-foreground-600 text-xs font-medium whitespace-nowrap">
                    <i className="ri-subtract-line"></i>{item.change}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}